import { useEffect, useState } from 'react'

export default function Gdpr() {
    const [data, setData] = useState(null)
    useEffect(() => {
        const getGDPR = async () => {
            const responseGql = await callApiAsync('getGDPRdata')
            setData(responseGql.data.data.data.entry.componentsBuilder[0].html)
        }
        getGDPR()
    }, [])
    return (
        <div style={{ color: 'white', maxWidth: 1500, margin: 'auto' }}>
            <div dangerouslySetInnerHTML={{ __html: data }} />
        </div>
    )
}
